import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const TeamV2InsightsContainer = () => {
    return (
        <Box sx={{ p: 3 }}>
            <Paper sx={{ p: 4, textAlign: 'center' }}>
                <Typography variant="h4" gutterBottom color="primary">
                    📊 Team Insights
                </Typography>
                <Typography variant="body1">
                    Team analytics and insights page - Coming soon
                </Typography>
            </Paper>
        </Box>
    );
};

export default TeamV2InsightsContainer;
